import React, { createContext } from "react";

import { DataObject } from "web_modules/PipelineViewer/shared";

export const PipelineFieldsContext = createContext<{
  pipelineData: DataObject[];
  updatePinnedMessage: Function;
}>({
  pipelineData: [],
  updatePinnedMessage: () => alert("not implemented; please connect me to views provider"),
});
PipelineFieldsContext.displayName = "Pipeline fields context";

type Props = {
  loadedPipelineData: any[];
  updatePinnedMessage: Function;
};

export const PipelineDataProvider: React.FunctionComponent<Props> = ({
  loadedPipelineData,
  updatePinnedMessage,
  children,
}) => {
  return (
    <PipelineFieldsContext.Provider
      value={{ pipelineData: loadedPipelineData, updatePinnedMessage }}
    >
      {children}
    </PipelineFieldsContext.Provider>
  );
};
